import { CbhIcon, Illustration, Text, Title } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";
import { isRebrandingEnabled } from "@src/appV2/redesign/Rebranding/workerAppRebranding";

import { HomeIndicator } from "../../components/HomeIndicator";
import { SlideTextContainer } from "../../components/SlideTextContainer";

function InterviewBookedCard() {
  return (
    <Box
      sx={{
        width: 254,
        backgroundColor: "common.white",
        borderRadius: "19px",
        boxShadow: "0px 2.4px 14.2px rgba(0, 0, 0, 0.04)",
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        padding: "9.5px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          width: "100%",
          height: 45,
          alignItems: "flex-start",
        }}
      >
        <Box
          sx={{
            width: "23.6px",
            height: "23.6px",
            borderRadius: "59px",
            backgroundColor: "common.white",
            border: "0.34px solid",
            borderColor: "border.primary",
            boxShadow: "0px 2.4px 14.2px rgba(0, 0, 0, 0.04)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "4.7px",
          }}
        >
          <CbhIcon type="close" size="xSmall" />
        </Box>
      </Box>

      <Stack spacing="19px" alignItems="center" sx={{ padding: "0 9.5px" }}>
        <Illustration type="shift-booked-small" sx={{ width: 104, height: 71 }} />

        <Text
          sx={{
            fontSize: "24px",
            fontWeight: 400,
            lineHeight: "28px",
            letterSpacing: "-0.24px",
            color: "text.primary",
            textAlign: "center",
          }}
        >
          Your interview is booked!
        </Text>

        <Box
          sx={{
            width: 236,
            backgroundColor: "common.white",
            border: "0.6px solid",
            borderColor: "border.primary",
            borderRadius: "14px",
            padding: "10px",
            boxShadow: "0px 2.4px 14.2px rgba(0, 0, 0, 0.04)",
            display: "flex",
            flexDirection: "column",
            gap: "6px",
          }}
        >
          <Box
            sx={{
              backgroundColor: (theme) => theme.palette.warning.dark,
              borderRadius: "9.5px",
              padding: "3.5px 7px",
              width: "fit-content",
            }}
          >
            <Text
              sx={{
                fontSize: "8px",
                fontWeight: 400,
                lineHeight: "10px",
                letterSpacing: "-0.08px",
                color: "text.primary",
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              Fri, Jan 9 • Starts in 3 days
            </Text>
          </Box>

          <Stack direction="row" spacing="6px" alignItems="center">
            <CbhIcon
              type="sun-filled"
              size="xSmall"
              sx={{ width: 14, height: 14, color: "text.primary" }}
            />
            <Text
              sx={{
                fontSize: "14px",
                fontWeight: 500,
                lineHeight: "17px",
                letterSpacing: "-0.14px",
                color: "text.primary",
              }}
            >
              10:15 am - 10:45 am
            </Text>
          </Stack>

          <Text
            sx={{
              fontSize: "8px",
              fontWeight: 500,
              lineHeight: "10px",
              letterSpacing: "-0.08px",
              color: "text.primary",
            }}
          >
            Lead Teacher • Kiara&apos;s Childcare Center • 2 mi
          </Text>
        </Box>
      </Stack>

      <Box sx={{ padding: "0 9.5px", paddingBottom: "0", width: "100%" }}>
        <Box
          sx={{
            backgroundColor: "primary.main",
            borderRadius: "59px",
            padding: "9.5px 14px",
            boxShadow: "0px 2.4px 14.2px rgba(0, 0, 0, 0.04)",
            textAlign: "center",
          }}
        >
          <Text
            sx={{
              fontSize: "9.5px",
              fontWeight: 500,
              lineHeight: "10px",
              letterSpacing: "-0.09px",
              color: "common.white",
            }}
          >
            Browse more jobs
          </Text>
        </Box>

        <HomeIndicator />
      </Box>
    </Box>
  );
}

export function InstantInterviewSlide() {
  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          flex: 58,
          position: "relative",
          overflow: "hidden",
          minHeight: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            height: 388,
            "@media (max-height: 740px)": { zoom: 0.85 },
            "@media (max-height: 670px)": { zoom: 0.75 },
          }}
        >
          <InterviewBookedCard />
        </Box>
        <Box
          sx={(theme) => ({
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            height: "50%",
            background: `linear-gradient(to bottom, transparent 0%, transparent 36%, ${isRebrandingEnabled() ? theme.palette.background.tertiary : theme.palette.background.quaternary} 75%)`,
            pointerEvents: "none",
          })}
        />
      </Box>

      <SlideTextContainer>
        <Stack spacing={0} alignItems="center" sx={{ margin: 0 }}>
          <Title variant="h3" component="h1" sx={{ textAlign: "center", margin: 0 }}>
            Book guaranteed
          </Title>
          <Title variant="h3" component="h2" sx={{ textAlign: "center", margin: 0 }}>
            interview slots with
          </Title>
          <Title variant="h3" component="h2" sx={{ textAlign: "center", margin: 0 }}>
            workplaces instantly
          </Title>
        </Stack>
      </SlideTextContainer>
    </Box>
  );
}
